module.exports = __webpack_public_path__ + "img/ready_sell.bd422269.svg";